import useI18n from '@app/shared/vue/composables/use-I18n'
import { segmentVisibilities } from '../types/index'
import type { SegmentVisibilityData } from '../types/index'

export default function useSegmentVisibilities(): SegmentVisibilityData {
  const I18n = useI18n()

  const visibilitiesData = {
    [segmentVisibilities.PRIVATE_VISIBLE]: {
      path: 'insights/icon-query-access-private.svg',
      name: I18n.t('companies_overview.segments_new.visibilities.private.name'),
      desc: I18n.t('companies_overview.segments_new.visibilities.private.desc'),
    },
    [segmentVisibilities.ADMIN_VISIBLE]: {
      path: 'insights/icon-query-access-admin.svg',
      name: I18n.t('companies_overview.segments_new.visibilities.admin.name'),
      desc: I18n.t('companies_overview.segments_new.visibilities.admin.desc'),
    },
    [segmentVisibilities.FIRM_VISIBLE]: {
      path: 'insights/icon-query-access-firm.svg',
      name: I18n.t('companies_overview.segments_new.visibilities.firm.name'),
      desc: I18n.t('companies_overview.segments_new.visibilities.firm.desc'),
    },
  }

  return visibilitiesData
}
